/**
 * 搜索逻辑： 假设关键字为 Account
 * 1. 不区分大小写
 * 2. xxx Account xxx 可以匹配成功
 * 3. Accountxxxxx 可以匹配成功， Accxxxxx 则匹配失败
 * 4. 正向匹配：即 Account / Accoun / Accou / Acco / Acc / Ac / A 都是匹配成功， ccount / ccoun 等则匹配失败
 * 5. 假设存在关键字 Account 和 Add， 输入 A 时需要两个都匹配到，输入 Ac 则只匹配 Account
 */

// 生成正向匹配的list
const getKeywordList = (keyword: string) => {
  const len = keyword.length;
  const list = [];
  for (let i = 0; i < len; i++) {
    list.push(keyword);
    keyword = keyword.slice(0, keyword.length - 1);
  }
  return list;
};

export const searchLogic = (value: string, keywordObj: object) => {
  // 匹配到的关键字集合
  const highlightKeywords = [];
  let resultList = [];
  // 以空格为分隔，划分单词，进行匹配
  const valueList = value.split(' ');
  for (const keyword in keywordObj) {
    const keywordReg = new RegExp(`^${keyword.toLowerCase()}`);
    const keywordList = getKeywordList(keyword);
    if (keywordList.length > 0) {
      // 对每个单词进行 关键字正向list 完全匹配
      keywordList.forEach((key) => {
        valueList.forEach((item) => {
          if (
            item.toLowerCase() === key.toLowerCase() || // 逻辑4
            keywordReg.test(item.toLowerCase()) // 逻辑3
          ) {
            if (highlightKeywords.indexOf(keyword) === -1) {
              resultList = resultList.concat(keywordObj[keyword]);
              highlightKeywords.push(keyword);
            }
          }
        });
      });
    }
  }
  return {
    highlightKeywords: highlightKeywords,
    result: resultList,
  };
};
